export default __webpack_public_path__ + "static/media/bP.8d84cf77.svg";